import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["withdrawalType", "destinationAddress"]
    static values = {
        memberAddresses: Object,
        selectTypeText: String,
        setAddressText: String
    }

    connect() {
        this.updateDestinationAddress()
    }

    updateDestinationAddress() {
        const selectedType = this.withdrawalTypeTarget.value
        const destinationAddress = this.memberAddressesValue[selectedType]

        if (selectedType && destinationAddress) {
            this.destinationAddressTarget.value = destinationAddress
            this.destinationAddressTarget.classList.remove('text-gray-500')
            this.destinationAddressTarget.classList.add('text-white')
        } else if (selectedType && !destinationAddress) {
            this.destinationAddressTarget.value = this.setAddressTextValue || '请先在个人资料中设置对应的提款地址'
            this.destinationAddressTarget.classList.remove('text-white')
            this.destinationAddressTarget.classList.add('text-gray-500')
        } else {
            this.destinationAddressTarget.value = this.selectTypeTextValue || '请先选择提现方式'
            this.destinationAddressTarget.classList.remove('text-white')
            this.destinationAddressTarget.classList.add('text-gray-500')
        }
    }
} 